/**
 *
 * @module tokenManagerExtrasMap
 *
 */

import Check from 'check-types';
import Logging from './../../logging/entry';
import RetryPolicy from './retryPolicy';

/**
 *
 * @class TokenManagerExtrasMap
 * @desc Provides additional configuration information used by the manager.
 *
 */
export default class TokenManagerExtrasMap {

    /**
     *
     * @param {Number} refreshThreshold
     * @param {RetryPolicy} autoRefreshRetryPolicy
     * @param {Object} [subjectTokenTypes]
     * @param {SDK.Logging.Logger} [logger=Logging]
     *
     */
    constructor(refreshThreshold, autoRefreshRetryPolicy, subjectTokenTypes, logger = Logging) {

        const errorMessage = {
            ctor: 'TokenManagerExtrasMap(refreshThreshold, autoRefreshRetryPolicy, subjectTokenTypes, logger)',
            get refreshThreshold() {
                return `${this.ctor} refreshThreshold should be a Number`;
            },
            get autoRefreshRetryPolicy() {
                return `${this.ctor} needs RetryPolicy instance`;
            },
            get subjectTokenTypes() {
                return `${this.ctor} subjectTokenTypes should be a non-empty Object. Assigning default values`;
            }
        };

        if (Check.not.number(refreshThreshold)) {
            logger.warn('TokenManagerExtrasMap', errorMessage.refreshThreshold);
        }

        if (Check.not.instanceStrict(autoRefreshRetryPolicy, RetryPolicy)) {
            logger.warn('TokenManagerExtrasMap', errorMessage.autoRefreshRetryPolicy);
        }

        if (Check.not.nonEmptyObject(subjectTokenTypes)) {
            logger.warn('TokenManagerExtrasMap', errorMessage.subjectTokenTypes);
        }

        /**
         *
         * @access public
         * @type {Number}
         * @desc Gets or sets a value that indicates when the access context should be refreshed.
         *
         */
        this.refreshThreshold = refreshThreshold;

        /**
         *
         * @access public
         * @type {RetryPolicy}
         * @desc Gets or sets the retry policy to help drive the retry behavior for service failures.
         *
         */
        this.autoRefreshRetryPolicy = autoRefreshRetryPolicy;

        /**
         *
         * @access public
         * @type {Object}
         * @desc Gets or sets the `subject_token_type` values to use with each grant type.
         *
         */
        this.subjectTokenTypes = subjectTokenTypes || this.getDefaultSubjectTokenTypes();

    }

    /* #region private: */

    /**
     *
     * @access private
     * @desc Default subjectTokenTypes, act as a fallback for the configuration values.
     * @returns {Object}
     *
     */
    getDefaultSubjectTokenTypes() {

        return {
            device: 'urn:bamtech:params:oauth:token-type:device',
            account: 'urn:bamtech:params:oauth:token-type:account',
            temporary: 'urn:ietf:params:oauth:token-type:jwt'
        };

    }

}



// WEBPACK FOOTER //
// ./src/services/configuration/tokenManagerExtrasMap.js